import { model as i18n } from '!/i18n'
import { combine, createEvent, restore, sample, type Store } from 'effector'
import { model as router } from '~/core/router'
import { LibraryTabs, QUERY_LIBRARY_TAB, type LibraryTabNames } from './index.h'
import { isQueryTabNotEqualNextTab } from './lib'

export const $libraryTabNames: Store<LibraryTabNames> = combine(
  i18n.$t,
  ({ t }) => ({
    favorites: t('favorites'),
    purchased: t('purchased'),
  })
)

export const selectLibraryActiveTab = createEvent<LibraryTabs>()

sample({
  clock: selectLibraryActiveTab,
  source: router.$query,
  filter: (query, nextTab) => isQueryTabNotEqualNextTab(query, nextTab),
  fn: (_, nextTab) => ({ [QUERY_LIBRARY_TAB]: nextTab }),
  target: router.navigatePushQuery,
})

export const $libraryActiveTab = restore(selectLibraryActiveTab, null)
